import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditServiceQuotePartSource extends TermCreateEdit {
    /**
     * @returns {string} The term type.
     */
    getType() {
        return "service_quote_part_source";
    }
}
